import React from 'react';
import { AdminLoading } from './AdminLoading';
import { UnauthorizedAccess } from './UnauthorizedAccess';
import { useAdmin } from '../context/AdminContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin, user, loading, error } = useAdmin();

  // Show loading spinner while checking authentication
  if (loading) {
    return <AdminLoading />;
  }

  // Show unauthorized page if user is not admin
  if (!isAdmin || error) {
    return (
      <UnauthorizedAccess
        userRole={user?.role}
        userName={user ? `${user.firstName} ${user.lastName}` : undefined}
        user={user || undefined}
      />
    );
  }

  // Render admin content if user is authenticated as admin
  return <>{children}</>;
};

export default AdminRoute;
